exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payment-methods[data-v-451d9ff7]{padding:20px 0;text-align:center\n}\n@media (min-width:768px){\n.payment-methods[data-v-451d9ff7]{text-align:left\n}\n}\n@media (min-width:992px){\n.payment-methods[data-v-451d9ff7]{padding:0;text-align:center\n}\n}\n.payment-methods__label[data-v-451d9ff7]{height:21px;margin-left:3px\n}\n@media (min-width:576px){\n.payment-methods__label[data-v-451d9ff7]{height:23px\n}\n}\n@media (min-width:992px){\n.payment-methods__label[data-v-451d9ff7]{height:28px\n}\n}", ""]);

// exports
